import { classes, icons, Link } from '@portal/components'
import paths from 'paths'

const { ArrowUpRight } = icons

export const docsAreas = {
  authentication: 'sdk/latest/auth-and-authorization/cloud-authentication',
  authWebhook:
    'sdk/latest/auth-and-authorization/cloud-authentication#configure-ditto',
  authWebhookv5: 'sdk/v5/auth-and-authorization/cloud-authentication',
  authSharedKey:
    'key-concepts/authentication-and-authorization#shared-key-authentication',
  apiKey: 'cloud/http-api/auth-and-params#api-key',
  changelog: 'changelog',
  httpApi: 'cloud/http-api/getting-started',
  querySyntax: 'dql/query-syntax-legacy',
  kakfaConsumer: 'cloud/cdc#create-a-kafka-consumer',
  smallPeerInfo: 'cloud/portal/capturing-small-peer-info',
  legacySyntax: 'dql/query-syntax-legacy',
  dql: 'dql/dql',
  deviceMetadata: 'cloud/portal/capturing-small-peer-info#custom-user-metadata',
  mongoConnector: 'cloud/mongodb-connector',
  cloudCDC: 'cloud/cdc',
  connectSDK: 'sdk/latest/home',
}
export type DocsArea = keyof typeof docsAreas

type Props = {
  /**
   * An optional text to display in the link. Defaults to 'Read the docs'.
   */
  text?: string
  /**
   * An optional area of the docs to go to. If not provided, the link will go to
   * the root of the docs: https://docs.ditto.live.
   */
  docsArea?: DocsArea
  /**
   * An optional variant to use for the link. Defaults to 'accent'  (_not_ monochrome, which is primary)
   */
  variant?: 'accent' | 'primary'
  /**
   * A boolean to add an underline to the link
   */
  underline?: boolean
  /**
   * A boolean to show the external link icon. Defaults to true.
   */
  showIcon?: boolean
}
export default function ReadTheDocsLink({
  text = 'Read the docs',
  docsArea,
  variant = 'accent',
  underline,
  showIcon = true,
}: Props) {
  return (
    <Link
      href={paths.dittoDocs(docsArea)}
      isBlank
      className={classes(
        'inline-flex items-center',
        variant === 'accent'
          ? 'text-foreground-accent'
          : 'text-foreground-normal',
        {
          'underline underline-offset-2': underline,
        },
      )}
    >
      {text}
      {showIcon && <ArrowUpRight className="ml-1" />}
    </Link>
  )
}
